<div class="my-5">
  <div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="members || []" [loading]="loading"></sm-data-table-builder>
    <sm-dialog *ngIf="isDialogOpen" #dialog [dialog]="memberDialog"></sm-dialog>
    <sm-dialog #delete [dialog]="deleteDialog"></sm-dialog>
  </div>
</div>
